module.exports = __webpack_public_path__ + "static/media/dry-pop-up-notification.8bbfcaa4.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audios/dry-pop-up-notification.wav
// module id = 2609
// module chunks = 0